import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import companyLogoDark from "../../assets/images/NOVUS OMNIFLEET FINAL LOGO-01.png";
import companyLogoLight from "../../assets/images/NOVUS OMNIFLEET FINAL LOGO-02.png";
import SideNavApi from './Components/SideNavApi';

const ApiDocumentation = () => {
    const theme = useTheme();

    return (
        <Paper className="flex-1 flex flex-col w-full">
            <Box className="flex justify-between items-center h-[70px] border-b border-[#f0eff8] p-8 sm:p-4">
                <Box className="flex items-center justify-start gap-2">
                    <img
                        src={theme.palette.mode === 'light' ? companyLogoDark : companyLogoLight}
                        alt="Logo"
                        className="h-[40px]"
                    />
                </Box>
            </Box>
            <SideNavApi />
        </Paper>
    );
};

export default ApiDocumentation;
